import React from 'react';
import { Helmet } from 'react-helmet-async';
import {
  SectionTitle,
  SectionSubtitle,
  SectionDescription,
  Section,
  SectionContent,
} from '../styles/sections';
import { MarqueeWrapper, MarqueeTrack, ClubLogo } from '../styles/marquee';
import { ClubTypesWrap, ClubTypeTag, ClubTypeEmoji } from '../styles/whoUses';
import {
  OverlayHeroSection,
  OverlayHeroImage,
  OverlayHeroGradient,
  OverlayHeroContent,
} from '../styles/overlayHero';
import { clubs } from '../data/clubs';

const clubTypes = [
  { emoji: '⚽', label: 'Football Clubs' },
  { emoji: '🏉', label: 'Rugby Clubs' },
  { emoji: '🏏', label: 'Cricket Clubs' },
  { emoji: '🏑', label: 'Hockey Clubs' },
  { emoji: '🏀', label: 'Basketball Leagues' },
  { emoji: '🥍', label: 'Netball Clubs' },
];

// Duplicated so the track can loop seamlessly at a -50% translate.
const marqueeClubs = [...clubs, ...clubs];

function WhoUsesPlayfairPage() {
  return (
    <>
      <Helmet>
        <title>Who Uses Playfair</title>
        <meta name="description" content="Trusted by committees, captains, and club admins across every sport." />
        <link rel="canonical" href="https://playfair.online/who-uses-playfair" />
      </Helmet>

      <OverlayHeroSection>
        <OverlayHeroImage image="/american-football.jpg" />
        <OverlayHeroContent>
          <SectionSubtitle style={{ color: '#d1ff94' }}>Built For Every Team</SectionSubtitle>
          <SectionTitle style={{ color: '#fff', marginBottom: '0.75rem' }}>
            Who Uses Playfair
          </SectionTitle>
          <SectionDescription style={{ color: '#e5e7eb', marginBottom: 0, maxWidth: '600px' }}>
            Trusted by committees, captains, and club admins across every sport.
          </SectionDescription>
        </OverlayHeroContent>
      </OverlayHeroSection>

      <Section backgroundColor="#000" style={{ padding: '3rem 0' }}>
        <MarqueeWrapper>
          <MarqueeTrack>
            {marqueeClubs.map((club, index) => (
              <ClubLogo key={`${club}-${index}`} src={club} alt="Club logo" loading="lazy" />
            ))}
          </MarqueeTrack>
        </MarqueeWrapper>
      </Section>

      <Section backgroundColor="#f0efea">
        <SectionContent style={{ textAlign: 'center' }}>
          <SectionSubtitle style={{ color: '#1f2937', textAlign: 'center' }}>
            Every Sport, One App
          </SectionSubtitle>
          <SectionTitle style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
            Which Sport Do You Play?
          </SectionTitle>
          <ClubTypesWrap>
            {clubTypes.map((type) => (
              <ClubTypeTag key={type.label}>
                <ClubTypeEmoji>{type.emoji}</ClubTypeEmoji>
                {type.label}
              </ClubTypeTag>
            ))}
          </ClubTypesWrap>
        </SectionContent>
      </Section>
    </>
  );
}

export default WhoUsesPlayfairPage;
